import { render, staticRenderFns } from "./ResolDeltaSolBxPlus_2d10.vue?vue&type=template&id=d98cea18&"
import script from "./ResolDeltaSolBxPlus_2d10.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaSolBxPlus_2d10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports